// extracted by mini-css-extract-plugin
module.exports = {"divider":"_c117e88"};